import {
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { SplitButtonFiltersComponent } from '../split-button-filters/split-button-filters.component';

import { ButtonFilterService } from '../../services/button-filter.service';
import { IDataFilterDropdown } from '../split-filter-dropdown/split-filter-dropdown.component';
import { IFilter } from '../../interfaces/ifilter';
import { Filter } from '../../models/filter';
import { IDataFilterRangeDate } from '../split-filter-range-date/split-filter-range-date.component';
import { FilterModel, IFilterModel } from '../../models/filter-model';
import { Paginator } from 'primeng/paginator';

@Component({
  selector: 'split-table',
  templateUrl: './split-table.component.html',
  styleUrls: ['./split-table.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SplitTableComponent implements OnInit, OnChanges {
  @ContentChildren('coluna') colunas!: QueryList<TemplateRef<any>>;
  @ContentChildren('parentHeader') parentHeaders!: QueryList<TemplateRef<any>>;
  @ContentChildren('header') headers!: QueryList<TemplateRef<any>>;
  @ContentChildren('expands') expands!: QueryList<TemplateRef<any>>;
  @ContentChildren('linha') linhas!: QueryList<TemplateRef<any>>;

  @Input() dados: Array<any> = [];
  @Input() theme: String = "primary";
  @Input() checklist: boolean = false;

  @Input() loading = false;

  @Input() widthColumns: Array<number> = [];

  public computedData: Array<any> | null = null;

  @Input() filters: IFilterModel[] = [];
  @Output() pageChange = new EventEmitter();

  @Output() filterChange = new EventEmitter();

  @Output() onCheckSelection = new EventEmitter();

  @Input() filter!: Filter;


  @Input() filterArray!: FilterModel;

  expandBody: any = {}


  @ViewChild('pPaginator') paginatorRef!: Paginator

  first: number = 0;
  @Input() rows: number = 10;
  @Input() totalRecords: number = 0;
  @Input() paginator = false;


  onPageChange(event: PageEvent | any) {
      this.first = event.first;
      this.rows = event.rows;
      
      event.page = event.page + 1;
      this.pageChange.emit(event);
  }

  constructor(private buttonFilterService: ButtonFilterService) {
  
  }


  ngOnChanges(changes: SimpleChanges): void {
    if(changes['filters']) {
      //console.log(this.filters)
    }
  }

  ngOnInit(): void {
    if (this.checklist) {
      this.dados = this.dados.map((dado) => {
        return { ...dado, checklist: false };
      });
    }
  }

  checkAll(ev: any) {
    this.dados.forEach(x => x.checklist = ev.checked)
  }

  isAllChecked() {
    return this.dados.every((_) => _.checklist);
  }
  emitEventChecked() {
    let dadosSelected = this.dados.filter(x => x.checklist);
    this.onCheckSelection.emit(dadosSelected);
  }
  remove(filter: IFilterModel, position: number | null = null) {

    if(position == null) {
      this.filterArray.delete(filter.key);
    } else {
      this.filterArray.deleteByFilter(filter, position as number);
    }
    //this.buttonFilterService.remove(filter, position);
    //this.filterArray.removeByFilter(filter, position as number);
   this.filterChange.emit(this.filterArray);
  }

  clearFilter() {
    
  }

  expandInfo(position: number) {
    this.expandBody[position] = !this.expandBody[position];
  }

  setPage(currentPage: number): void {
    this.paginatorRef.changePage(currentPage);
   }
}
interface PageEvent {
    first: number;
    rows: number;
    page: number;
    pageCount: number;
}